import { z } from "zod";

import { FormField } from "../../../FormEngine/types";
import { FormConfig, FormState } from "@components/PatientForms/FormContext/types";
import { EatingHabitsData } from "src/revamp/types/PatientFormTypes";
import { multiSelectResponseSchema } from "../../common/schemaHelper";

/**
 * Eating Habits form schema
 * 
 * This schema defines the fields for the Eating Habits form
 * using the FormEngine component.
 */
export const eatingHabitsSchema: FormField[] = [
	{
		type: "numeric",
		name: "mealsAndSnacks",
		title: "Meals and Snacks",
		description: "How many meals and snacks do you eat daily?",
		label: "Number of meals and snacks",
		fieldProps: {
			min: 0,
			max: 7,
			decimalScale: 0,
			sx: { width: { xs: "100%", md: "50%" } },
		},
	},
	{
		type: "multi-select-response",
		name: "eatingBehaviors",
		title: "Eating Behaviors",
		description: "Do you exhibit any of the following eating behaviors?",
		options: [
			"Eating when stressed",
			"Eating when emotional",
			"Eating when bored",
			"Eating when tired",
			"Experiencing intense food cravings",
			"Waking up at night to eat",
			"Other",
		].map(option => ({ label: option, value: option })),
		schema: [
			{
				type: "input",
				name: "description",
				label: "Please describe",
			}
		],
		fieldProps: {
			includeNoneOption: true,
		},
	},
	{
		type: "input",
		name: "foodAndDrink",
		title: "Recent Consumption",
		description: "List all food and drink you've consumed over the last 24 hours",
		label: "List foods/drinks (comma separated)",
	},
	{
		type: "multi-select-response",
		name: "eatingDisorders",
		title: "Food Relationship Questions",
		description: "Have you been diagnosed with, or do you suspect you may have, any of the following?",
		options: [
			"Binge Eating disorder",
			"Night eating disorder",
			"Anorexia",
			"Bulimia",
			"Orthorexia",
			"Other Eating Disorder",
		].map(option => ({ label: option, value: option })),
		schema: [
			{
				type: "input",
				name: "description",
				label: "Please describe",
			},
		],
		fieldProps: {
			includeNoneOption: true,
		},
		rule: z.array(multiSelectResponseSchema).min(1, { message: "Please select at least one option" }),
	},
];

export const emptyRecentConsumption = (
  data: EatingHabitsData,
  formState: FormState,
  formConfig: FormConfig,
) => {
  console.log("setting recent consumption to empty string");
	console.log(formState.completedSteps)
  if (!formState.completedSteps.includes("eating-habits") && !formConfig.allowSkipSteps) {
    data.foodAndDrink = "";
  }
};

export default eatingHabitsSchema;